import Privacy from '../components/Privacy.vue'
import { bootstrapPage } from '../bootstrapPage'

bootstrapPage(Privacy)
